import Icons from "../../icons/sidebar";
import {
  PhoneAndroid as PhoneAndroidIcon,
  MoreHoriz as MoreHorizIcon,
  AccountBalanceWallet as WalletIcon,
  AccountBalance as BankIcon,
  Business as BusinessIcon,
  Timeline as ActivityIcon,
  Tune as SettingsIcon,
  Assessment as ReportsIcon,
  Notifications as NotifIcon,
  SendToMobile as DisbursementIcon,
  Receipt as RepaymentIcon,
  CompareArrows as ReconcileIcon,
  CorporateFare as CompanyIcon,
  ArrowDownward as DepositIcon,
  ArrowUpward as WithdrawIcon,
  AutoGraph as AutoInvestIcon,
  Gavel as RecoveryIcon,
} from "@mui/icons-material";

export interface IMenuItem {
  title: string;
  Icon?: any;
  path: string;
  subMenu?: IMenuItem[];
  permissions?: string[];
  users?: string[];
  visible: boolean;
}

export interface IMenuSection {
  section: string;
  items: IMenuItem[];
}

export const MenuSections = (isSuperUser: boolean): IMenuSection[] => [
  {
    section: "",
    items: [
      {
        title: "Dashboard",
        Icon: Icons.HomeIcon,
        path: "/dashboard",
        visible: true,
      },
    ],
  },
  {
    section: "Lending",
    items: [
      {
        title: "Loans",
        Icon: Icons.RequestQuoteIcon,
        path: "/admin/loan",
        visible: true,
      },
      {
        title: "Investments",
        Icon: Icons.MonetizationOnIcon,
        path: "/admin/investment",
        visible: true,
      },
      {
        title: "AutoInvest",
        Icon: AutoInvestIcon,
        path: "/admin/autoinvest",
        visible: true,
      },
      {
        title: "Recovery",
        Icon: RecoveryIcon,
        path: "/admin/recovery",
        visible: true,
      },
    ],
  },
  {
    section: "Devices",
    items: [
      {
        title: "Catalog",
        Icon: Icons.PhoneAndroidIcon ?? PhoneAndroidIcon,
        path: "/admin/devices",
        visible: true,
      },
      {
        title: "Orders",
        Icon: Icons.LocalShippingIcon,
        path: "/admin/device-orders",
        visible: true,
      },
    ],
  },
  // ================================================================
  // Phase 6: Manual Transactions
  // ================================================================
  {
    section: "Manual Operations",
    items: [
      {
        title: "Deposits",
        Icon: DepositIcon,
        path: "/admin/manual-deposits",
        visible: true,
      },
      {
        title: "Withdrawals",
        Icon: WithdrawIcon,
        path: "/admin/manual-withdrawals",
        visible: true,
      },
      {
        title: "Disbursements",
        Icon: DisbursementIcon,
        path: "/admin/manual-disbursements",
        visible: true,
      },
      {
        title: "Repayments",
        Icon: RepaymentIcon,
        path: "/admin/manual-repayments",
        visible: true,
      },
      {
        title: "Company Accounts",
        Icon: CompanyIcon,
        path: "/admin/company-accounts",
        visible: true,
      },
      {
        title: "Reconciliation",
        Icon: ReconcileIcon,
        path: "/admin/reconciliation",
        visible: true,
      },
    ],
  },
  {
    section: "Finance",
    items: [
      {
        title: "Transactions",
        Icon: Icons.PaidIcon,
        path: "/admin/transactions",
        visible: true,
      },
      {
        title: "Wallets",
        Icon: WalletIcon,
        path: "/admin/wallets",
        visible: true,
      },
      {
        title: "Banks",
        Icon: BankIcon,
        path: "/admin/banks",
        visible: true,
      },
      {
        title: "Reports",
        Icon: ReportsIcon,
        path: "/admin/reports",
        visible: true,
      },
    ],
  },
  {
    section: "Admin",
    items: [
      {
        title: "Users",
        Icon: Icons.GroupsIcon,
        path: "/users",
        visible: true,
      },
      {
        title: "Deletion Requests",
        Icon: Icons.GroupsIcon,
        path: "/users/deletion-requests",
        visible: true,
      },
      {
        title: "Institutions (KYC)",
        Icon: BusinessIcon,
        path: "/admin/business",
        visible: true,
      },
      {
        title: "Notifications",
        Icon: NotifIcon,
        path: "/admin/notifications",
        visible: true,
      },
      {
        title: "Activity Log",
        Icon: ActivityIcon,
        path: "/admin/activity",
        visible: true,
      },
      {
        title: "Platform Settings",
        Icon: SettingsIcon,
        path: "/admin/platform-settings",
        visible: true,
      },
    ],
  },
];

export const MobileMenuList = (): IMenuItem[] => [
  { title: "Home",    Icon: Icons.HomeIcon,        path: "/dashboard",         visible: true },
  { title: "Loans",   Icon: Icons.RequestQuoteIcon, path: "/admin/loan",        visible: true },
  { title: "Wallets", Icon: WalletIcon,             path: "/admin/wallets",     visible: true },
  { title: "Reports", Icon: ReportsIcon,            path: "/admin/reports",     visible: true },
  { title: "Users",   Icon: Icons.GroupsIcon,       path: "/users",             visible: true },
];

export const MenuList = (isSuperUser: boolean): IMenuItem[] => {
  return MenuSections(isSuperUser).flatMap((s) => s.items);
};

export default MenuList;